/**
 * Active journey for the shared /wizard shell.
 * Data: assets/wizard-journeys.js (generated from journeys/*.json).
 * Resolve: query j, then session bz_journey_id, then the saved browser journey, then w4.
 */
(function () {
  var DOM = {
    gender_spayed: 'spayed',
    overview: 'plan_overview'
  };

  function journeys() {
    return window.BZ_WIZARD_JOURNEYS || {};
  }

  function resolve() {
    var all = journeys();
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      params = new URLSearchParams();
    }
    var fromQuery = params.get('j');
    var fromSession = '';
    var fromSaved = '';
    try {
      fromSession = sessionStorage.getItem('bz_journey_id') || '';
    } catch (e) {}
    try {
      fromSaved = localStorage.getItem('bz_journey_id') || '';
    } catch (e2) {}
    var id = (all[fromQuery] && fromQuery) || (all[fromSession] && fromSession) || (all[fromSaved] && fromSaved) || 'w4';
    var journey = all[id] || all.w4;
    if (!journey) throw new Error('No wizard journey loaded');
    if (window.Buybox2Journey && window.Buybox2Journey.rememberJourney) {
      window.Buybox2Journey.rememberJourney(journey.journey_id);
    } else {
      try {
        sessionStorage.setItem('bz_journey_id', journey.journey_id);
        localStorage.setItem('bz_journey_id', journey.journey_id);
      } catch (e3) {}
    }
    window.BzWizard._journey = journey;
    return journey;
  }

  function current() {
    return window.BzWizard._journey || resolve();
  }

  function domSteps(journey) {
    var j = journey || current();
    var quiz = (j.quiz && j.quiz.step_ids || []).filter(function (id) { return id !== 'get_started'; });
    var plan = (j.plan && j.plan.step_ids || []).map(function (id) {
      return id === 'snacks' ? 'extras' : id;
    });
    var steps = quiz.concat(plan).map(function (id) { return DOM[id] || id; });
    if (steps.indexOf('profile') === -1) steps.push('profile');
    return steps;
  }

  var GIFT_CODES = {
    w3: ['FREEGIFT-W3', 'GRATISCADEAU-W3'],
    lamb_tripe: ['FREEEXTRA-W4', 'GRATISEXTRA-W4'],
    duck_trainers: ['FREEEXTRA-W4', 'GRATISEXTRA-W4'],
    beef_trainers: ['FREEEXTRA-W4', 'GRATISEXTRA-W4'],
    sardine_oil: ['FREEEXTRA-W4', 'GRATISEXTRA-W4']
  };
  var SAMPLE_CODES = {
    w3: ['FREESAMPLE-W3', 'GRATISPROEF-W3'],
    w4: ['FREESAMPLE-W4', 'GRATISPROEF-W4'],
    w5: ['FREESAMPLE-W5', 'GRATISPROEF-W5']
  };

  function discountLocale() {
    var path = '';
    try { path = window.location.pathname || ''; } catch (e) {}
    if (/^\/en(?:\/|$)/i.test(path)) return 'en';
    var lang = '';
    try { lang = String(document.documentElement.lang || '').toLowerCase(); } catch (e2) {}
    if (lang.indexOf('en') === 0) return 'en';
    return 'nl';
  }

  function discountCode(enCode, nlCode) {
    var en = String(enCode || '').trim();
    var nl = String(nlCode || '').trim();
    if (discountLocale() === 'nl') return nl || en;
    return en || nl;
  }

  function pairCode(pair) {
    if (!pair) return '';
    return discountCode(pair[0], pair[1]);
  }

  window.BzWizard = {
    _journey: null,
    resolve: resolve,
    current: current,
    id: function () { return current().journey_id; },
    flow: function () { return current().acquisition_flow; },
    domSteps: domSteps,
    discountLocale: discountLocale,
    discountCode: discountCode,
    giftCode: function (id) { return pairCode(GIFT_CODES[id]); },
    sampleCode: function (journeyId) { return pairCode(SAMPLE_CODES[journeyId]); }
  };
})();
